export default __webpack_public_path__ + "static/media/beach.10c8ab85.png";